module.exports = __webpack_public_path__ + "static/media/il.033c38c0.svg";